import React from "react"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"

export const OrSeparator = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 17px;
`

export const OrText = styled.div`
  font-size: 13px;
  font-weight: ${fonts.weight.medium};
  align-self: flex-end;
  opacity: 0.6;
  padding: 0 15px 1.5px;
  text-transform: uppercase;
`

const HorizontalLine = styled.hr`
  flex: 1;
  border: none;
  border-top-width: 0.5px;
  border-top-style: solid;
  opacity: 0.6;
`

export const OrDivider: React.FC<{ className?: string }> = ({ className }) => (
  <OrSeparator className={className}>
    <HorizontalLine />
    <OrText>or</OrText>
    <HorizontalLine />
  </OrSeparator>
)
